import { render, staticRenderFns } from "./PackageQuickInfo.vue?vue&type=template&id=0e015b04&"
import script from "./PackageQuickInfo.vue?vue&type=script&lang=js&"
export * from "./PackageQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./PackageQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageQuickInfo.vue"
export default component.exports